import { Injectable } from '@angular/core';
import { Providers, Msal2Provider, LoginType, TemplateHelper, LoginChangedEvent } from '@microsoft/mgt';
import { PublicClientApplication, AccountInfo, InteractionType } from '@azure/msal-browser';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { Client } from '@microsoft/microsoft-graph-client';
import { BehaviorSubject, Subject, Subscription, lastValueFrom } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Y } from '@angular/cdk/keycodes';
import { User } from '@microsoft/microsoft-graph-types';

@Injectable({
    providedIn: 'root',
})
export class GraphAuthService {
    private graphClient?: Client;

    public account$ = new BehaviorSubject<AccountInfo | null>(null);

    constructor(private msal?: MsalService) {
        //console.log('graph-auth.service');
        //this.initialize();
        this.initMsal();
    }

    async initMsal() {
        if (!this.msal) return;
        const accounts = this.msal?.instance.getAllAccounts();
        if (accounts.length > 0) {
            this.msal.instance.setActiveAccount(accounts[0]);
            console.log(accounts[0]);
        }
        this.updateAccountSubject(accounts[0] ?? null);
    }

    public async updateAccountSubject(account: AccountInfo | null) {
        try {
            this.account$.next(account);
        } catch (error) {
            console.error(error);
            this.account$.next(null);
        }

        return this.account$.getValue();
    }
    private readonly config = {
        auth: {
            clientId: 'c90067f7-0ccf-43ee-a05c-30b601f5e721', //,
            //redirectUri: 'https://hybridtest.touchtime.app/index.html',
            //postLogoutRedirectUri: 'https://hybridtest.touchtime.app/index.html'
        },
        cache: {
            cacheLocation: 'localStorage', // Change from "sessionStorage" to "localStorage"
            storeAuthStateInCookie: true, // Recommended for IE11/Edge
        },
    };

    public stateChange$ = new Subject<LoginChangedEvent>();

    private readonly scopes = ['User.ReadWrite', 'Mail.ReadWrite', 'Mail.ReadWrite.Shared', 'Mail.Send', 'Calendars.ReadWrite'];

    private initState: InitState = InitState.Uninitialized;

    // BJS 20250210
    public async isAuthenticated(): Promise<boolean> {
        await this.initialize();

        return (Providers.globalProvider as Msal2Provider).publicClientApplication.getAllAccounts().length > 0;
    }

    public async signIn(): Promise<void> {
        await this.initialize();

        if (!this.msal) {
            alert('didnt work try again');
            return;
        }

        try {
            const result = await lastValueFrom(this.msal.loginPopup({ popupWindowAttributes: { popupPosition: { left: 0, top: 0 } }, scopes: this.scopes }));

            if (result) {
                this.msal?.instance.setActiveAccount(result.account);
                Providers.globalProvider.login?.();

                this.updateAccountSubject(result.account);

                // this.authenticated = true;
                // this.u = await this.getUser();
            }
        } catch (reason: any) {
            console.error(reason);
            //   this.alertsService.addError(
            //     'Login failed',
            //     JSON.stringify(reason, null, 2),
            //   );
        }
    }

    public async signOut(): Promise<void> {
        if (!this.msal) return;

        try {
            await lastValueFrom(this.msal.logoutPopup());
            await Providers.globalProvider.logout?.();
            // Providers.globalProvider.u?.(null);

            //@ts-ignore
            window.location.reload(true);
        } finally {
            this.updateAccountSubject(null);
            this.graphClient = undefined;
        }
    }

    public async initialize() {
        switch (this.initState) {
            case InitState.Initialized:
                return;
            case InitState.Initializing:
                function timeout() {
                    return new Promise((resolve) => setTimeout(resolve, 50));
                }

                while (this.initState === InitState.Initializing) {
                    await timeout();
                }

                return;
        }

        this.initState = InitState.Initializing;

        let pca = new PublicClientApplication(this.config);

        await pca.initialize();

        Providers.globalProvider = new Msal2Provider({
            loginType: LoginType.Popup,
            publicClientApplication: pca,
            clientId: this.config.auth.clientId,
            scopes: this.scopes,
        });

        TemplateHelper.setBindingSyntax('[[', ']]');

        const currentAccount = (Providers.globalProvider as Msal2Provider).publicClientApplication.getAllAccounts()[0];

        this.updateAccountSubject(currentAccount ?? null);

        const authProvider = new AuthCodeMSALBrowserAuthenticationProvider((Providers.globalProvider as Msal2Provider).publicClientApplication, {
            account: currentAccount,
            scopes: this.scopes,
            interactionType: InteractionType.Popup,
        });

        this.graphClient = Client.initWithMiddleware({ authProvider: authProvider });

        (Providers.globalProvider as Msal2Provider).onStateChanged(async (event: LoginChangedEvent) => {
            this.stateChange$.next(event);
            try {
                this.updateAccountSubject(await this.getAccount());
            } catch {
                this.updateAccountSubject(null);
            }
        });

        this.initState = InitState.Initialized;
    }

    /**
     * Returns the graph client.
     *
     * @returns the graph client.
     */
    public async getGraphClient(): Promise<Client | undefined> {
        if (!this.graphClient) {
            await this.initialize();
        }

        return this.graphClient;
    }

    public async getAccount(): Promise<AccountInfo> {
        console.log('grap-auth.service - 08');

        await this.initialize();

        console.log('grap-auth.service - 09');

        let accounts = (Providers.globalProvider as Msal2Provider).publicClientApplication.getAllAccounts();

        console.log('grap-auth.service - 10');

        if (accounts.length < 1) {
            throw new Error('No user accounts found.');
        }

        console.log('grap-auth.service - 11');

        return (Providers.globalProvider as Msal2Provider).publicClientApplication.getAllAccounts()[0];
    }

    public async getAccessToken(account?: AccountInfo): Promise<string> {
        if (account === null) {
            account = await this.getAccount();
        }

        const accessTokenRequest = {
            scopes: this.scopes,
            account: account,
        };

        await this.initialize();

        let response = await (Providers.globalProvider as Msal2Provider).publicClientApplication.acquireTokenSilent(accessTokenRequest);

        return response.accessToken;
    }
}

enum InitState {
    Uninitialized,
    Initializing,
    Initialized,
}
